<div class="indicator">
	<i [ngClass]="iconClass()!"></i>
	<div class="progress">
		<div class="determinate" [ngStyle]="{ width: width }"></div>
	</div>
</div>
